// extracted by mini-css-extract-plugin
module.exports = {"container":"_22mmmKv3hdK5ij3x2WrtDx","slide":"J34jpQ5F_ENv4Po6nxssK","active":"_1ETgRLiwLY5mIGjf-NkCPU"};